module.exports = __webpack_public_path__ + "static/ogp-a9bbdee0178baf3b550e9be4bf2f7599.jpg";